/* Input/output slideshow. Snap carousel, auto-advance, dots. Pauses the moment
   anyone touches it -- an auto-advancing slide that yanks itself away while
   someone is reading the prompt is worse than no autoplay at all. */
(function () {
  function init(root) {
    if (root.dataset.revealReady) return;
    root.dataset.revealReady = '1';

    var track = root.querySelector('[data-reveal-track]');
    var slides = track ? [].slice.call(track.children) : [];
    if (!track || slides.length < 1) return;

    var dotsWrap = root.querySelector('[data-reveal-dots]');
    var timer = null;
    var paused = false;

    var dots = slides.map(function (s, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'reveal__dot';
      b.setAttribute('aria-label', 'Slide ' + (i + 1));
      b.addEventListener('click', function () { pause(); go(i); });
      if (dotsWrap) dotsWrap.appendChild(b);
      return b;
    });

    function nearest() {
      var x = track.scrollLeft, best = 0, bd = Infinity;
      slides.forEach(function (s, i) {
        var d = Math.abs(s.offsetLeft - x);
        if (d < bd) { bd = d; best = i; }
      });
      return best;
    }

    function mark(i) {
      dots.forEach(function (d, n) { d.setAttribute('aria-current', n === i ? 'true' : 'false'); });
    }

    function go(i) {
      var n = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[n].offsetLeft, behavior: 'smooth' });
      mark(n);
    }

    function start() {
      var s = parseFloat(root.getAttribute('data-reveal-auto'));
      if (!s || paused || slides.length < 2) return;
      stop();
      timer = setInterval(function () { go(nearest() + 1); }, s * 1000);
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function pause() { paused = true; stop(); }

    root.querySelector('[data-reveal-next]').addEventListener('click', function () { pause(); go(nearest() + 1); });
    root.querySelector('[data-reveal-prev]').addEventListener('click', function () { pause(); go(nearest() - 1); });

    ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach(function (e) {
      root.addEventListener(e, pause, { passive: true });
    });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', function () { if (!paused) start(); });

    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () { mark(nearest()); });
    }, { passive: true });

    mark(0);

    // only run the clock while it is actually on screen
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { e.isIntersecting ? start() : stop(); });
      }, { threshold: 0.25 }).observe(root);
    } else {
      start();
    }
  }

  function boot() { document.querySelectorAll('[data-reveal]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
